import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		paddingTop: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
	},
	backButton: {
		backgroundColor: token('color.skeleton'),
		width: '16px',
		height: '16px',
		borderRadius: token('radius.small'),
	},
	heading: {
		backgroundColor: token('color.skeleton'),
		width: '120px',
		height: '16px',
		borderRadius: token('radius.small'),
	},
	icon: {
		backgroundColor: token('color.skeleton'),
		width: '24px',
		height: '24px',
		borderRadius: token('radius.small'),
	},
	menuItemText: {
		backgroundColor: token('color.skeleton'),
		height: '16px',
		width: '100%',
		borderRadius: token('radius.small'),
	},
	menuItemTextWrapper: {
		flex: 1,
	},
});

const MenuItemSkeleton = () => (
	<Flex gap="space.100" alignItems="center">
		<Box xcss={styles.icon} />
		<Box xcss={styles.menuItemTextWrapper}>
			<Box xcss={styles.menuItemText} />
		</Box>
	</Flex>
);

export const ItamSettingsSkeleton = (): React.JSX.Element => (
	<Stack space="space.300" xcss={styles.container}>
		<Flex gap="space.100" alignItems="center">
			<Box xcss={styles.backButton} />
			<Box xcss={styles.heading} />
		</Flex>
		<Stack space="space.100" grow="hug">
			<MenuItemSkeleton />
			<MenuItemSkeleton />
			<MenuItemSkeleton />
			<MenuItemSkeleton />
			<MenuItemSkeleton />
			<MenuItemSkeleton />
			<MenuItemSkeleton />
		</Stack>
	</Stack>
);
